/* eslint-disable react/require-default-props */
import React from 'react';
import { Box, Button, Typography } from '@mui/material';
import { SECTION_LABEL_SX } from './sidebarInfoGrid';

type Props = {
  name: string;
  buttonText?: string | React.ReactNode;
  buttonAction?: () => void;
  microLabel?: boolean;
  hideTitle?: boolean;
  flat?: boolean;
};

export default function SectionHeader({
  name,
  buttonText,
  buttonAction,
  microLabel,
  hideTitle,
  flat,
}: Props) {
  if (!name) return null;
  return (
    <div
      className="section-header"
      style={flat ? { border: 'none', padding: 0 } : undefined}>
      {!hideTitle && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {microLabel ? (
            <Typography sx={SECTION_LABEL_SX}>{name}</Typography>
          ) : (
            <Typography variant="h3">{name}</Typography>
          )}
        </Box>
      )}
      {buttonText && buttonAction && (
        <Button
          variant="text"
          className="text-btn"
          onClick={buttonAction}
          sx={
            typeof buttonText === 'string'
              ? undefined
              : {
                  minWidth: 0,
                  paddingY: 0,
                  paddingX: 2,
                }
          }>
          {buttonText}
        </Button>
      )}
    </div>
  );
}
